import React from 'react';
import { Box, Container, Typography, Paper } from '@mui/material';
import DebugConversations from '../components/DebugConversations';

const SimpleDashboard = () => {
  return (
    <Container maxWidth="lg">
      <Box sx={{ mt: 4, mb: 4 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Dashboard
        </Typography>
        
        <Paper elevation={3} sx={{ p: 3, mb: 3 }}>
          <Typography variant="h6" gutterBottom>
            Your Conversations
          </Typography>
          <Typography variant="body2" color="text.secondary" paragraph>
            View and manage all your customer conversations below.
          </Typography>
        </Paper>
        
        <DebugConversations />
      </Box>
    </Container>
  );
};

export default SimpleDashboard;
